import { render } from "./CreateAutomaticOrder.vue?vue&type=template&id=7d449a16&scoped=true&ts=true"
import script from "./CreateAutomaticOrder.vue?vue&type=script&lang=ts"
export * from "./CreateAutomaticOrder.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d449a16"]])

export default __exports__